import React, { FC, useEffect, useState } from 'react';
import { CategoryFieldGroup } from '../../models/CategoryFieldGroup';
import { useFormikContext } from 'formik';
import { CustomFieldBuilder } from '../utilities/CustomFieldBuilder';
import { useLocale } from '../../contexts/localeContext';
import { useSelector } from 'react-redux';
import { IAppState } from '../../store/types';

type Props = {
    supportedFields: CategoryFieldGroup[],
    currentUser?: any
}

const UserDetailsDetailsTab: FC<Props> = ({ supportedFields, currentUser = undefined }) => {
    const formik = useFormikContext<any>();
    const { translate } = useLocale();
    const customFieldBuilder = new CustomFieldBuilder(formik, translate);
    const siteId = useSelector((state: IAppState) => state.site.site.value)
    const [userSiteId, setUserSiteId] = useState<number>(siteId);

    useEffect(() => {
        setUserSiteId(currentUser?.siteId ? currentUser?.siteId : siteId);
    }, [currentUser, siteId])

    //When global site selector is change make sure you clear field that depend on it
    useEffect(() => {
        if (!!!currentUser?.id){
            formik.setFieldValue("company", "");
            formik.setFieldValue("department", "");
            formik.validateField("email");
        }
    }, [siteId])

    return (
        <div className="flex flex-col">
            <div>
                {supportedFields.filter((fieldGroup) => fieldGroup.fields?.length > 0).map((fieldGroup, index) => {
                    return <>
                        {index > 0
                            ? <div className="pt-10 pb-1 text-portal-blue-primary-shade2">{fieldGroup.heading}</div>
                            : null}
                        {fieldGroup.fields
                            .reduce((formFields, field) => {
                                return customFieldBuilder.buildFormField(formFields, field, undefined, undefined, userSiteId)
                            }, new Array(0))
                            .map(fieldBundle => <div className="flex flex-row pt-2 relative">{fieldBundle.length === 1
                                ? fieldBundle[0].span
                                    ? fieldBundle[0].content
                                    : <>{fieldBundle[0].content}
                                        <div className="flex flex-col flex-1 pl-3"></div></>
                                : fieldBundle.map(field => field.content)}</div>)}</>
                })}
            </div>
        </div>
    );
}

export default UserDetailsDetailsTab;

